window.OKJS = window.OKJS || {};
(function (OKJS){
        OKJS.BeforeAfterSlider = {

        settings: {
            
        },

        init: function () {
            var baSliders = document.querySelectorAll('.js-ba-slider');

            if (baSliders.length > 0) {
                OKJS.BeforeAfterSlider.setupBaSlider(baSliders);
            }
        },
        setupBaSlider: function (baSliders) {

            OKJS.BeforeAfterSlider.updateWidth(baSliders);
            
            for (var i = 0; i < baSliders.length; i++) {
                var handle = baSliders[i].querySelector('.ba-slider__handle'),
                    resize = baSliders[i].querySelector('.ba-slider__resize'),
                    container = baSliders[i];

                this.addEvent(handle, resize, container);
            }

            // Update sliders on resize. 
            var throttledBaSliderUpdateWidth = OKJS.Global.throttle(function () { OKJS.BeforeAfterSlider.updateWidth(baSliders) }, 500, { trailing: true });
            window.addEventListener('resize', function () { requestAnimationFrame(throttledBaSliderUpdateWidth) }, Modernizr.passiveeventlisteners ? { passive: true } : false);
            
        },
        addEvent : function(handle, resize,container) {

            handle.addEventListener((whatInput.ask() === 'touch') ? 'touchstart' : 'mousedown',function(event) {
                    OKJS.BeforeAfterSlider.dragEvent(event, handle, resize, container);
                },
                Modernizr.passiveeventlisteners ? { passive: false } : false);
        },
        updateWidth: function (baSliders) {
            for (var i = 0; i < baSliders.length; i++) {
                // Adjust the slider
                var SliderWidth = baSliders[i].offsetWidth + 'px';
                baSliders[i].querySelector('.ba-slider__resize img').style.width = SliderWidth;
            }
        },
        dragEvent: function (e, dragElement, resizeElement, container) {
            
            dragElement.classList.add('ba-draggable');
            resizeElement.classList.add('ba-resizable');

            // Check if it's a mouse or touch event and pass along the correct value
            var startX = (whatInput.ask() === 'touch') ? e.changedTouches[0].pageX : e.pageX;

            // Get the initial position
            var dragWidth = dragElement.offsetWidth,
                posX = dragElement.getBoundingClientRect().left + document.body.scrollLeft + dragWidth - startX,
                containerOffset = container.getBoundingClientRect().left + document.body.scrollLeft,
                containerWidth = container.offsetWidth;

            // Set limits
            var minLeft = containerOffset - 10;
            var maxLeft = containerOffset + containerWidth - dragWidth + 10;

            // Calculate the dragging distance on mousemove.
            dragElement.parentElement.addEventListener((whatInput.ask() === 'touch') ? 'touchmove' : 'mousemove', function (e) {
                if (dragElement.classList.contains('ba-draggable')) {

                    // Check if it's a mouse or touch event and pass along the correct value
                    var moveX = (whatInput.ask() === 'touch') ? e.changedTouches[0].pageX : e.pageX;

                    var leftValue = moveX + posX - dragWidth;

                    // Prevent going off limits
                    if (leftValue < minLeft) {
                        leftValue = minLeft;
                    } else if (leftValue > maxLeft) {
                        leftValue = maxLeft;
                    }

                    // Translate the handle's left value to masked divs width.
                    var widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

                    // Set the new values for the slider and the handle. 
                    dragElement.style.left = widthValue;
                    resizeElement.style.width = widthValue;
                } 
                
            }, Modernizr.passiveeventlisteners ? { passive: true } : false);


            // Bind mouseup events to stop dragging.
            dragElement.parentElement.addEventListener((whatInput.ask() === 'touch') ? 'touchend' : 'mouseup', function (e) {
                dragElement.classList.remove('ba-draggable');
                resizeElement.classList.remove('ba-resizable');

                // Unbind all events for performance
                if (whatInput.ask() === 'touch') {
                    dragElement.removeEventListener('touchstart', function (event) { OKJS.BeforeAfterSlider.dragEvent(event, handle, resize, container); }, Modernizr.passiveeventlisteners ? { passive: false } : false);
                    dragElement.parentElement.removeEventListener('touchmove', Modernizr.passiveeventlisteners ? { passive: true } : false);
                } else {
                    dragElement.removeEventListener('mousedown', function (event) { OKJS.BeforeAfterSlider.dragEvent(event, handle, resize, container); }, Modernizr.passiveeventlisteners ? { passive: false } : false);
                    dragElement.parentElement.removeEventListener('mousemove', Modernizr.passiveeventlisteners ? { passive: true } : false);
                }

            }, Modernizr.passiveeventlisteners ? { passive: true } : false);
            
            e.preventDefault();
            
        }
    };
}(window.OKJS));
